export function isActionBlock(item) {
  return 'label' in item && 'type' in item && 'linkText' in item;
}
export function isActionBlockArray(item) {
  return Array.isArray(item) && isActionBlock(item[0]);
}
